module.exports = __webpack_public_path__ + "static/media/logoblack copy 2.e749b2e0.png";